// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Used in the following:
    (updated: 2021.02.22)

    signin.html
*/
.ez-sign-in-dialog-layout-container {
  display: grid;
  grid-template-columns: auto 50% auto;
  grid-template-rows: auto;
  grid-column-gap: 20px;
  grid-row-gap: 0;
  align-content: center;
  justify-content: space-between;
  background-color: transparent;
}

.ez-sign-in-dialog-container {
  margin-top: 30px;
  padding: 30px;
  background-color: rgba(250, 250, 255, 0.85);
  border-color: var(--ezClockerNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ez-sign-in-dialog-subbanner {
  text-align: center;
  font-size: 24pt;
  font-weight: normal;
  color: var(--ezClockerGray);
}

.ez-sign-in-dialog-banner {
  margin-bottom: 10px;
  color: var(--ezClockerNavy);
  font-size: 48pt;
  font-weight: bold;
}

/** Password Viewer Styles **/
.ez-sign-in-password-show-hide-img {
  height: 24px;
  padding-top: 2px;
}

/*
.ezFixedDialogLogoContainer {
    vertical-align: middle;
    text-align: center;
    font-size: 14pt;
    margin-bottom: 10px;
}

.ezFixedDialogLogoImage {
    width: 24px;
    height: 24px;
    vertical-align: middle;
}

.ezFixedDialogInputLabel {
    font-weight: bold;
    font-size: 16pt;
}

.ezFixedDialogInput {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    font-size: 18pt;
}

.ezDialogInputTitle {
    font-weight: bold;
    font-size: 16pt;
}

input.ezDialogTextInput {
    width: 100%;
    font-size: 18pt;
}
*/
/*
img.viewPasswordImage {
    display: none;
    width: 24px;
    height: 24px;
    padding: 0;
}

td.passwordPeekContainer {
    width: 24px;
    border-style: none;
    margin: 0;
    padding: 0;
}

div.passwordPeek {
    text-align: left;
    padding: 4px;
    background-color: rgb(15 71 119 / 40%);
    color: var(--ezClockerWhite);
    font-weight: bold;
    font-family: monospace;
    font-size: 12pt;
    word-wrap: break-word;
    position: absolute;
}

div.passwordPeekBlank {
    text-align: left;
    font-style: italic;
}


.ui-effects-transfer {
    background-color: rgb(15 71 119 / 25%);
    border-style: dashed;
    border-width: 1px;
    border-color: #000000;
}

pre.visualPasswordSpace {
    border-left-style: solid;
    border-right-style: solid;
    border-top-style: none;
    border-bottom-style: none;
    border-width: 1px;
    border-color: #7cd0fd;
    padding: 0;
    margin: 0;
}

div.peekCountDown {
    text-align: center;
    display: hidden;
    color: #0f4777;
    font-size: 12pt;
    font-family: monospace;
    font-weight: bold;
}

div.signInBox {
    width: 30%;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
    background-color: rgb(250 250 250 / 100%);
    border: 1px solid black;
    border-radius: 5px;
    margin-top: 35px;
}

td.signUpCell {
    padding-top: 20px;
    text-align: center;
}


td.inputCell {
    padding-bottom: 8px;
}

td.signInLabel {
    font-weight: bold;
    font-size: 16pt;
}

td.buttonCell {
    padding-top: 10px;
    padding-bottom: 10px;
}

div.signInBanner {
    text-align: center;
    font-size: 48pt;
    font-weight: bold;
}

div.errorBox {
    text-align: center;
    color: red;
    font-size: 14pt;
    display: none;
    padding-top: 8px;
    padding-bottom: 8px;
}
*/
/*
    ===================================================================================================================
    [Class Group]
    Animated Sign-In Backgrounds
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignup-animated-gradient-background
        @-webkit-keyframes ezSignup-animated-gradient-background-keyframes
        @keyframes ezSignup-animated-gradient-background-keyframes
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignup-animated-gradient-background {
  width: 100%;
  height: 100vh;
  background-size: 300% 300%;
  background-image: linear-gradient(-45deg, rgba(255, 153, 0, 0.9) 0%, rgba(255, 153, 0, 0.9) 25%, rgba(255, 153, 0, 0.9) 50%, var(--ezClockerWhite) 100%);
  -webkit-animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;
  animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;
}

@-webkit-keyframes ezSignup-animated-gradient-background-keyframes {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes ezSignup-animated-gradient-background-keyframes {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignin-animated-blob-background-part1::before
        @keyframes ezSignin-animated-blob-background-part1-shape
        .ezSignin-animated-blob-background-part2::before
        @keyframes ezSignin-animated-blob-background-part2-shape
        .ezSignin-animated-blob-background-part3::before
        @keyframes ezSignin-animated-blob-background-part3-shape
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignin-animated-blob-background-part1::before {
  scale: 75%;
  position: absolute;
  content: "";
  left: 10%;
  top: 5%;
  width: 450px;
  height: 450px;
  background: rgba(15, 71, 119, 0.3);
  border-radius: 62% 47% 82% 35%/45% 45% 80% 66%;
  will-change: border-radius, transform, opacity;
  animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;
  display: block;
  z-index: -1;
  -webkit-animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;
}

@keyframes ezSignin-animated-blob-background-part1-shape {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  34% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 5px, 0) rotateZ(0.01deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  67% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, -3px, 0) rotateZ(0.01deg);
  }
}
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignin-animated-blob-background-slider-thumb::before
        @keyframes ezSignin-animated-blob-background-slider-shape
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignin-animated-blob-background-part2::before {
  scale: 75%;
  position: absolute;
  content: "";
  left: 35%;
  top: 40%;
  width: 450px;
  height: 450px;
  background: rgba(255, 153, 0, 0.5);
  border-radius: 62% 47% 82% 35%/45% 45% 80% 66%;
  will-change: border-radius, transform, opacity;
  animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;
  display: block;
  z-index: -1;
  -webkit-animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;
}

@keyframes ezSignin-animated-blob-background-part2-shape {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  34% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 5px, 0) rotateZ(0.01deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  67% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, -3px, 0) rotateZ(0.01deg);
  }
}
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignin-animated-blob-background
        .ezSignin-animated-blob-background-slider-thumb::before
        @keyframes ezSignin-animated-blob-background-slider-shape
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignin-animated-blob-background-part3::before {
  scale: 75%;
  position: absolute;
  content: "";
  left: 60%;
  top: 15%;
  width: 450px;
  height: 450px;
  background: rgba(109, 110, 112, 0.5);
  border-radius: 62% 47% 82% 35%/45% 45% 80% 66%;
  will-change: border-radius, transform, opacity;
  animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;
  display: block;
  z-index: -1;
  -webkit-animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;
}

@keyframes ezSignin-animated-blob-background-part3-shape {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  34% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 5px, 0) rotateZ(0.01deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  67% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, -3px, 0) rotateZ(0.01deg);
  }
}`, "",{"version":3,"sources":["webpack://./public/sign-in/ez-signin.css"],"names":[],"mappings":"AAAA;;;;;CAAA;AAOA;EACI,aAAA;EACA,oCAAA;EACA,wBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA,6BAAA;AACA;EACI,YAAA;EACA,gBAAA;AAAJ;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAuCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AA2GA;;;;;CAAA;AAOA;;;;;;;;;;;;CAAA;AAaA;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,wJAAA;EAKA,oFAAA;EACA,4EAAA;AATJ;;AAYA;EACI;IACI,2BAAA;EATN;EAYE;IACI,6BAAA;EAVN;EAaE;IACI,2BAAA;EAXN;AACF;AAcA;EACI;IACI,2BAAA;EAZN;EAeE;IACI,6BAAA;EAbN;EAgBE;IACI,2BAAA;EAdN;AACF;AAiBA;;;;;;;;;;;;CAAA;AAaA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,8CAAA;EACA,8CAAA;EACA,2EAAA;EACA,cAAA;EACA,WAAA;EACA,mFAAA;AAfJ;;AAkBA;EAEI;IAEI,8CAAA;IACA,gDAAA;EAjBN;EAoBE;IACI,8CAAA;IACA,kDAAA;EAlBN;EAqBE;IACI,gDAAA;EAnBN;EAsBE;IACI,kDAAA;IACA,mDAAA;EApBN;AACF;AAuBA;;;;;;;;;;;CAAA;AAYA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,8CAAA;EACA,8CAAA;EACA,2EAAA;EACA,cAAA;EACA,WAAA;EACA,mFAAA;AArBJ;;AAwBA;EAEI;IAEI,8CAAA;IACA,gDAAA;EAvBN;EA0BE;IACI,8CAAA;IACA,kDAAA;EAxBN;EA2BE;IACI,gDAAA;EAzBN;EA4BE;IACI,kDAAA;IACA,mDAAA;EA1BN;AACF;AA6BA;;;;;;;;;;;;CAAA;AAaA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,8CAAA;EACA,8CAAA;EACA,2EAAA;EACA,cAAA;EACA,WAAA;EACA,mFAAA;AA3BJ;;AA8BA;EAEI;IAEI,8CAAA;IACA,gDAAA;EA7BN;EAgCE;IACI,8CAAA;IACA,kDAAA;EA9BN;EAiCE;IACI,gDAAA;EA/BN;EAkCE;IACI,kDAAA;IACA,mDAAA;EAhCN;AACF","sourcesContent":["/*\n    Used in the following:\n    (updated: 2021.02.22)\n\n    signin.html\n*/\n\n.ez-sign-in-dialog-layout-container {\n    display: grid;\n    grid-template-columns: auto 50% auto;\n    grid-template-rows: auto;\n    grid-column-gap: 20px;\n    grid-row-gap: 0;\n    align-content: center;\n    justify-content: space-between;\n    background-color: transparent;\n}\n\n.ez-sign-in-dialog-container {\n    margin-top: 30px;\n    padding: 30px;\n    background-color: rgba(250, 250, 255, 0.85);\n    border-color: var(--ezClockerNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n.ez-sign-in-dialog-subbanner {\n    text-align: center;\n    font-size: 24pt;\n    font-weight: normal;\n    color: var(--ezClockerGray);\n}\n\n.ez-sign-in-dialog-banner {\n    margin-bottom: 10px;\n    color: var(--ezClockerNavy);\n    font-size: 48pt;\n    font-weight: bold;\n}\n\n/** Password Viewer Styles **/\n.ez-sign-in-password-show-hide-img {\n    height: 24px;\n    padding-top: 2px\n}\n\n/*\n.ezFixedDialogLogoContainer {\n    vertical-align: middle;\n    text-align: center;\n    font-size: 14pt;\n    margin-bottom: 10px;\n}\n\n.ezFixedDialogLogoImage {\n    width: 24px;\n    height: 24px;\n    vertical-align: middle;\n}\n\n.ezFixedDialogInputLabel {\n    font-weight: bold;\n    font-size: 16pt;\n}\n\n.ezFixedDialogInput {\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    font-size: 18pt;\n}\n\n.ezDialogInputTitle {\n    font-weight: bold;\n    font-size: 16pt;\n}\n\ninput.ezDialogTextInput {\n    width: 100%;\n    font-size: 18pt;\n}\n*/\n\n\n\n/*\nimg.viewPasswordImage {\n    display: none;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n}\n\ntd.passwordPeekContainer {\n    width: 24px;\n    border-style: none;\n    margin: 0;\n    padding: 0;\n}\n\ndiv.passwordPeek {\n    text-align: left;\n    padding: 4px;\n    background-color: rgb(15 71 119 / 40%);\n    color: var(--ezClockerWhite);\n    font-weight: bold;\n    font-family: monospace;\n    font-size: 12pt;\n    word-wrap: break-word;\n    position: absolute;\n}\n\ndiv.passwordPeekBlank {\n    text-align: left;\n    font-style: italic;\n}\n\n\n.ui-effects-transfer {\n    background-color: rgb(15 71 119 / 25%);\n    border-style: dashed;\n    border-width: 1px;\n    border-color: #000000;\n}\n\npre.visualPasswordSpace {\n    border-left-style: solid;\n    border-right-style: solid;\n    border-top-style: none;\n    border-bottom-style: none;\n    border-width: 1px;\n    border-color: #7cd0fd;\n    padding: 0;\n    margin: 0;\n}\n\ndiv.peekCountDown {\n    text-align: center;\n    display: hidden;\n    color: #0f4777;\n    font-size: 12pt;\n    font-family: monospace;\n    font-weight: bold;\n}\n\ndiv.signInBox {\n    width: 30%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 30px;\n    background-color: rgb(250 250 250 / 100%);\n    border: 1px solid black;\n    border-radius: 5px;\n    margin-top: 35px;\n}\n\ntd.signUpCell {\n    padding-top: 20px;\n    text-align: center;\n}\n\n\ntd.inputCell {\n    padding-bottom: 8px;\n}\n\ntd.signInLabel {\n    font-weight: bold;\n    font-size: 16pt;\n}\n\ntd.buttonCell {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\ndiv.signInBanner {\n    text-align: center;\n    font-size: 48pt;\n    font-weight: bold;\n}\n\ndiv.errorBox {\n    text-align: center;\n    color: red;\n    font-size: 14pt;\n    display: none;\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    Animated Sign-In Backgrounds\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezSignup-animated-gradient-background\n        @-webkit-keyframes ezSignup-animated-gradient-background-keyframes\n        @keyframes ezSignup-animated-gradient-background-keyframes\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        all\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezSignup-animated-gradient-background {\n    width: 100%;\n    height: 100vh;\n    background-size: 300% 300%;\n    background-image: linear-gradient(-45deg,\n            rgba(255, 153, 0, 0.9) 0%,\n            rgba(255, 153, 0, 0.9) 25%,\n            rgba(255, 153, 0, 0.9) 50%,\n            var(--ezClockerWhite) 100%);\n    -webkit-animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;\n    animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;\n}\n\n@-webkit-keyframes ezSignup-animated-gradient-background-keyframes {\n    0% {\n        background-position: 0% 50%;\n    }\n\n    50% {\n        background-position: 100% 50%;\n    }\n\n    100% {\n        background-position: 0% 50%;\n    }\n}\n\n@keyframes ezSignup-animated-gradient-background-keyframes {\n    0% {\n        background-position: 0% 50%;\n    }\n\n    50% {\n        background-position: 100% 50%;\n    }\n\n    100% {\n        background-position: 0% 50%;\n    }\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezSignin-animated-blob-background-part1::before\n        @keyframes ezSignin-animated-blob-background-part1-shape\n        .ezSignin-animated-blob-background-part2::before\n        @keyframes ezSignin-animated-blob-background-part2-shape\n        .ezSignin-animated-blob-background-part3::before\n        @keyframes ezSignin-animated-blob-background-part3-shape\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezSignin-animated-blob-background-part1::before {\n    scale: 75%;\n    position: absolute;\n    content: \"\";\n    left: 10%;\n    top: 5%;\n    width: 450px;\n    height: 450px;\n    background: rgba(15, 71, 119, 0.3);\n    border-radius: 62% 47% 82% 35% / 45% 45% 80% 66%;\n    will-change: border-radius, transform, opacity;\n    animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;\n    display: block;\n    z-index: -1;\n    -webkit-animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;\n}\n\n@keyframes ezSignin-animated-blob-background-part1-shape {\n\n    0%,\n    100% {\n        border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\n    }\n\n    34% {\n        border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\n        transform: translate3d(0, 5px, 0) rotateZ(0.01deg);\n    }\n\n    50% {\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\n    }\n\n    67% {\n        border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\n        transform: translate3d(0, -3px, 0) rotateZ(0.01deg);\n    }\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezSignin-animated-blob-background-slider-thumb::before\n        @keyframes ezSignin-animated-blob-background-slider-shape\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        all\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezSignin-animated-blob-background-part2::before {\n    scale: 75%;\n    position: absolute;\n    content: \"\";\n    left: 35%;\n    top: 40%;\n    width: 450px;\n    height: 450px;\n    background: rgba(255, 153, 0, 0.5);\n    border-radius: 62% 47% 82% 35% / 45% 45% 80% 66%;\n    will-change: border-radius, transform, opacity;\n    animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;\n    display: block;\n    z-index: -1;\n    -webkit-animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;\n}\n\n@keyframes ezSignin-animated-blob-background-part2-shape {\n\n    0%,\n    100% {\n        border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\n    }\n\n    34% {\n        border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\n        transform: translate3d(0, 5px, 0) rotateZ(0.01deg);\n    }\n\n    50% {\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\n    }\n\n    67% {\n        border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\n        transform: translate3d(0, -3px, 0) rotateZ(0.01deg);\n    }\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezSignin-animated-blob-background\n        .ezSignin-animated-blob-background-slider-thumb::before\n        @keyframes ezSignin-animated-blob-background-slider-shape\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        all\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezSignin-animated-blob-background-part3::before {\n    scale: 75%;\n    position: absolute;\n    content: \"\";\n    left: 60%;\n    top: 15%;\n    width: 450px;\n    height: 450px;\n    background: rgba(109, 110, 112, 0.5);\n    border-radius: 62% 47% 82% 35% / 45% 45% 80% 66%;\n    will-change: border-radius, transform, opacity;\n    animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;\n    display: block;\n    z-index: -1;\n    -webkit-animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;\n}\n\n@keyframes ezSignin-animated-blob-background-part3-shape {\n\n    0%,\n    100% {\n        border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\n    }\n\n    34% {\n        border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\n        transform: translate3d(0, 5px, 0) rotateZ(0.01deg);\n    }\n\n    50% {\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\n    }\n\n    67% {\n        border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\n        transform: translate3d(0, -3px, 0) rotateZ(0.01deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
